import { sha256Hex } from "./sha256";
import type { ConstantsManifest } from "./types";

/**
 * Integrity checksum over board + gold + constants (§2).
 *
 * The payload is built by hand rather than by JSON.stringify-ing the puzzle so
 * that key order, whitespace and any field added to the JSON later cannot
 * change the digest. A client verifying this must produce the same bytes, so
 * the format is frozen: pipe-separated, constants in the fixed order below.
 */
export function puzzlePayload(board: string, gold: number, c: ConstantsManifest): string {
  return [
    board,
    String(gold),
    String(c.minLen),
    String(c.heatCap),
    String(c.heatStep),
    String(c.goldMult),
    String(c.bullets),
    String(c.multMax),
  ].join("|");
}

export function puzzleChecksum(board: string, gold: number, c: ConstantsManifest): string {
  return "sha256:" + sha256Hex(puzzlePayload(board, gold, c));
}

export function verifyChecksum(board: string, gold: number, c: ConstantsManifest, expected: string): boolean {
  return puzzleChecksum(board, gold, c) === expected;
}
